import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { FiMove } from "react-icons/fi";
import { ImageTile, ImageTileProps } from "./components/ImageTile";

interface SortableImageTileProps extends ImageTileProps {
	id: string;
}

export const SortableImageTile: React.FC<SortableImageTileProps> = ({
	id,
	...tileProps
}) => {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
		isDragging,
	} = useSortable({ id });

	const style: React.CSSProperties = {
		transform: CSS.Transform.toString(transform),
		transition,
		opacity: isDragging ? 0.5 : 1,
		cursor: isDragging ? "grabbing" : "grab",
	};

	return (
		<div
			ref={setNodeRef}
			style={style}
			className="relative"
			{...attributes}
			{...listeners}
		>
			<div className="absolute top-2 left-2 z-[1] flex h-6 w-6 items-center justify-center rounded bg-white/80 text-gray-400 shadow-sm">
				<FiMove size={12} />
			</div>
			<ImageTile {...tileProps} />
		</div>
	);
};
